<template>
  <div v-show="progress">
    <div class="dimmed"/>
    <vue-ellipse-progress
        class="progress"
        :loading="true"
        color="#7579ff"
        animation="loop 700 1000"
        fontSize="1.5rem"
        font-color="white"
    >
      <span
          v-show="progressLength !== undefined && progressCnt !== undefined"
          slot="legend-value"
      >
        {{ progressCnt }} / {{ progressLength }}
      </span>
      <span
          v-show="text !== undefined"
          class="legend-caption"
          slot="legend-caption"
      >
        {{ text }}
      </span>
    </vue-ellipse-progress>
  </div>
</template>
<script>
import {
  VueEllipseProgress,
} from "vue-ellipse-progress";

export default {
  components: {
    VueEllipseProgress,
  },
  props: [
    'progress',
    'progressLength',
    'progressCnt',
    'text'
  ],
  data() {
    return {}
  },
  methods: {},
  watch: {},
  computed: {},
}
</script>
<style lang="scss">
.dimmed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.3;
  z-index: 1000000;
}

.progress {
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  width: 100%;
  height: 100%;
  z-index: 1000000;

  .ep-hidden{
    opacity: 1;
  }

  .ep-legend--value__counter{
    display: none;
  }

  .legend-caption{
    color: #FFFFFF;
    display: inline-block;
    margin-top: 10px;
  }
}
</style>